import { Drawer, Switch, message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PlayModal from "../../components/playModal";
import { productPage, productTypeList, purchaseAdd } from "../../API";
import { showLoding } from "../../utils/tool";
import ProductAdmin from "./shopComponents/productAdmin"
import PurchaseHistory from "./shopComponents/purchaseHistory"
import { useSelector } from "react-redux";
import Pagination from "../../components/Pagination";
import { useNavigate } from "react-router";
import ProductProfit from "./components/productProfit";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const [isShow, setIsShow] = useState(false); 
  const [activeTab, setActiveTab] = useState(0);

  // 进货
  const [productTitle, setProductTitle]: any = useState("")
  const [purchaseQuantity, setPurchaseQuantity]: any = useState(1);
  const [productId, setProductId]: any = useState(null);
  const handlePurchaseAdd = (password: string) => {
    if (!password) {
      message.error("請填寫完整資訊");
      return
    }
    showLoding(true);
    purchaseAdd({
      productId: productId,
      "purchaseQuantity": purchaseQuantity,
      "password": btoa((password || '').trim()),
    }).then((res) => {
      setIsShow(false)
      message.success("進貨成功");
      setActiveTab(2)
    }).catch((err) => {
    }).finally(() => {
      showLoding(false);
    })
  }

  const [tabIndex, setTabIndex] = React.useState(0)
  const [categoryLi, setCategoryLi] = React.useState<any>([])
  const handleCategory = () => {
    productTypeList()
      .then((res) => {
        setCategoryLi(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    handleCategory()
  }, [token])

  const [productPrict, setProductPrict] = React.useState<any>(0)
  const [pageSize, setPageSize] = React.useState(20)
  const [totalPages, setTotalPages] = React.useState(0)
  const [productList, setProductList] = React.useState<any>([])
  const [pageIndex, setPageIndex] = React.useState(1)
  const handleproductPage = (page: number) => {
    productPage({
      "pageNum": pageIndex,
      "pageSize": pageSize,
      "params": {
        "title": "",
        "cfgCode": categoryLi[tabIndex]?.cfgGroupSort
      }
    }).then((res) => {
      setProductList(res.data.records)
      setTotalPages(res.data.total)
    }).catch((err) => {
      console.log(err)
    })
  }
  useEffect(() => {
    handleproductPage(pageIndex)
  }, [pageIndex, tabIndex])

  const navigate = useNavigate()

  return (
    <div className="">
      <div className="flex items-center pb-[15px] h5:mx-[16px]"
        style={{
          borderBottom: "1px solid rgba(0, 0, 0, .2)"
        }}>
        <div className={`${activeTab === 0 ? 'text-[#181512] font-bold' : 'text-[#595959]'} 
        flex-1 text-center text-[20px] hover:text-[#181512] cursor-pointer h5:text-[17px]`}
          onClick={() => setActiveTab(0)}>商品管理</div>
        <div className={`${activeTab === 1 ? 'text-[#181512] font-bold' : 'text-[#595959]'} 
        flex-1 text-center text-[20px] hover:text-[#181512] cursor-pointer h5:text-[17px]`}
          onClick={() => setActiveTab(1)}>商品進貨</div>
        <div className={`${activeTab === 2 ? 'text-[#181512] font-bold' : 'text-[#595959]'} 
          flex-1 text-center text-[20px] hover:text-[#181512] cursor-pointer h5:text-[17px]`}
          onClick={() => setActiveTab(2)}>進貨記錄</div>
        <div className={`${activeTab === 3 ? 'text-[#181512] font-bold' : 'text-[#595959]'} 
            flex-1 text-center text-[20px] hover:text-[#181512] cursor-pointer h5:text-[17px]`}
          onClick={() => setActiveTab(3)}>商品盈利</div>
      </div>
      <div className={`${activeTab === 0 ? 'block' : 'hidden'} mt-[26px]`}>
        {
          activeTab === 0 ?
            <ProductAdmin onRestock={(e: any) => {
              setActiveTab(1)
              setProductTitle(e.title)
              setProductId(e.productId)
              setProductPrict(e.originalPrice)
            }} />
            : null
        }
      </div>
      <div className={`${activeTab === 1 ? 'block' : 'hidden'} mt-[26px]`}>
        <div className="flex items-center pb-10 mb-10 border-b border-dashed border-[#e0d9c6] cursor-pointer"
          onClick={() => setOpen(true)}>
          <div className="text-[#181512] text-[16px] mr-[30px]">選擇商品</div>
          <div className="flex-1 flex items-center">
            <div className="flex-1 text-[#181512] text-[16px] line-clamp-1">{productTitle}</div>
            <img src={require("../../assets/image/icon1.png")} className="w-[16px]" alt="" />
          </div>
        </div>
        <div className="flex items-center pb-10 mb-10 border-b border-dashed border-[#e0d9c6]">
          <div className="text-[#181512] text-[16px] mr-[30px]">數量</div>
          <input type="text"
            value={purchaseQuantity}
            onChange={(e) => setPurchaseQuantity(e.target.value)}
            className="flex-1 line-clamp-1 text-[#181512] text-[16px] focus-visible:outline-none" />
        </div>
        <div className="p-16 bg-[#f2f2f2] rounded-[4px] my-20">
          <div className="flex items-center">
            <div className="flex-1 text-[#181512] text-[16px]">進貨價：</div>
            <div className=" text-[#181512] text-[16px]">USD$ {purchaseQuantity > 0 ? productPrict : 0}</div>
          </div>
          <div className="flex items-center pt-10">
            <div className="flex-1 text-[#181512] text-[16px]">總金額： </div>
            <div className=" text-[#ee0a24] text-[16px] font-bold">USD$ {purchaseQuantity * (productPrict ? parseFloat(productPrict.replace(/,/g, '')) : 0)}</div>
          </div>
        </div>
        <div className="bg-[#000] rounded-[4px] text-center py-[14px] text-[#fff] text-[16px] cursor-pointer"
          onClick={() => {
            if (!purchaseQuantity || !productId) {
              message.error("請填寫完整資訊");
              return
            }
            setIsShow(true)
          }}>
          確認進貨
        </div>
      </div>
      <div className={`${activeTab === 2 ? 'block' : 'hidden'} mt-[26px]`}>
        {activeTab === 2 ? <PurchaseHistory /> : null} 
      </div>
      <div className={`${activeTab === 3 ? 'block' : 'hidden'} mt-[26px]`}>
        {activeTab === 3 ? <ProductProfit /> : null}
      </div> 

      {/* 选择商品 */}
      <Drawer
        title="選擇商品"
        placement={'bottom'}
        closable={false}
        onClose={() => {
          setOpen(false);
        }}
        open={open}
        key={'bottom'}
      >
        <div
          style={{
            height: '-webkit-fill-available'
          }}>
          <div className="flex items-start"
            style={{
              height: '-webkit-fill-available'
            }}>
            <div className="w-[140px] bg-[#fafafa] pl-16 pr-10 py-10"
              style={{
                height: '-webkit-fill-available',
                overflowY: 'scroll'
              }}>
              {
                categoryLi && categoryLi.map((item: any, index: number) => (
                  <div className={`${tabIndex === index ? 'font-bold' : ""} line-clamp-1 my-10 cursor-pointer`}
                    onClick={() => {
                      setPageIndex(1)
                      setTabIndex(index)
                    }
                    }
                    key={index}
                  >{item?.cfgName}</div>
                ))
              }
              {/* <div className=" line-clamp-1 my-10">洗衣機/電子衣櫥2</div>  */}
            </div>
            <div className="flex-1 pl-20 pt-10 pr-16"
              style={{
                height: '-webkit-fill-available',
                overflowY: 'scroll'
              }}>
              {
                productList.map((item: any, index: React.Key | null | undefined) => (
                  <div className="flex mb-10 cursor-pointer"
                    key={index}
                    onClick={() => {
                      setOpen(false)
                      setProductPrict(item?.originalPrice)
                      setProductId(item?.id)
                      setProductTitle(item?.title)
                    }}>
                    <img src={item?.imageUrl}
                      className="w-[100px] h-[100px] rounded-[10px] mr-[15px] object-cover
                  h5:w-[50px] h5:h-[50px]"
                      alt="" />
                    <div className="flex-1">
                      <div className="text-[16px] text-[#181512] font-bold mb-10 line-clamp-2 h5:mb-0 h5:line-clamp-1 h5:text-[14px]">
                        {item?.title}
                      </div>
                      <div className="text-[14px] text-[#ee0a24] h5:text-[12px]">進貨價：US$ {item?.originalPrice}</div>
                    </div>
                  </div>
                ))
              } 
              <div className="flex justify-center pb-[30px] pt-20">
                {
                  Math.ceil(totalPages / pageSize) > 1 ?
                    <Pagination
                      totalPages={Math.ceil(totalPages / pageSize)}
                      currentPage={pageIndex}
                      onPageChange={(page: number) => setPageIndex(page)}
                    />
                    : ''
                }
              </div>
            </div>
          </div>
        </div>
      </Drawer>

      <PlayModal isShow={isShow}
        productTitle={productTitle}
        purchaseQuantity={purchaseQuantity * (productPrict ? parseFloat(productPrict.replace(/,/g, '')) : 0)}
        onChange={() => {
          setIsShow(false)
        }}
        onConfirm={(e: string) => {
          handlePurchaseAdd(e)
        }} />
    </div>
  );
};

export default ComponentName;
